import { addMoney, compareMoney, type Money, negateMoney, zeroMoney } from '@taler/domain'
import type { Loan } from './types.ts'

export interface LoanPaymentSplit {
  readonly interest: Money
  readonly principal: Money
  readonly overpayment: Money
}

function min(a: Money, b: Money): Money {
  return compareMoney(a, b) <= 0 ? a : b
}

/** Today's figures run through the server's interest-first order; the server splits at the payment date. */
export function estimatePaymentSplit(
  amount: Money,
  loan: Pick<Loan, 'accruedInterest' | 'outstandingPrincipal'>,
): LoanPaymentSplit {
  const zero = zeroMoney(amount.currency)
  const interest = min(amount, compareMoney(loan.accruedInterest, zero) > 0 ? loan.accruedInterest : zero)
  const afterInterest = addMoney(amount, negateMoney(interest))
  const principal = min(
    afterInterest,
    compareMoney(loan.outstandingPrincipal, zero) > 0 ? loan.outstandingPrincipal : zero,
  )
  return { interest, principal, overpayment: addMoney(afterInterest, negateMoney(principal)) }
}
